// extracted by mini-css-extract-plugin
module.exports = {"giftProductTableCard":"styles_giftProductTableCard__8G6fE","productImage":"styles_productImage__eX9GX","cardCell__image":"styles_cardCell__image__14lyl"};